<template>
  <v-form
    v-if="editedQuestion"
    ref="form"
  >
    <v-container
      class="fill-height"
      fluid
    >
      <v-row>
        <v-col>
          <v-text-field
            v-model="editedQuestion.title"
            label="Titre"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="editedQuestion.description"
            label="Description"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="editedQuestion.help"
            label="Aide"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-combobox
            v-model="selectedType"
            :items="types"
            label="Type"
            @change="changeType"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox
            v-model="editedQuestion.visible"
            label="Visible ?"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col align="center">
          <v-btn
            v-if="mode === 'edit'"
            color="error"
            text
            @click="remove"
          >
            Supprimer
          </v-btn>
        </v-col>
        <v-col align="end">
          <v-btn
            text
            @click="close"
          >
            Annuler
          </v-btn>
        </v-col>
        <v-col align="center">
          <v-btn
            :disabled="!valid"
            color="blue"
            dark
            rounded
            @click="validate"
          >
            {{ mode === "create" ? "Ajouter" : "Modifier" }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mode: 'create',
      selectedType: 'Texte',
      editedQuestion: null,
      valid: true,
      types: ['Texte', 'Nombre', 'Date', 'Oui/Non', 'Oui/Non/Pourquoi'],
      nameRules: [(v) => !!v || 'Name is required'],
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    };
  },
  watch: {
    question(newVal) {
      this.mode = newVal.title !== '' ? 'edit' : 'create';
      this.selectedType = this.mode === 'edit' ? this.types[newVal.type] : 'Texte';
      this.editedQuestion = JSON.parse(JSON.stringify(newVal));
    },
  },
  methods: {
    async validate() {
      this.$refs.form.validate();
      await this.$store.dispatch(
        `question/${this.mode}`,
        JSON.parse(JSON.stringify(this.editedQuestion)),
      );
      this.close();
      this.$emit('refreshQuestion');
    },
    async remove() {
      await this.$store.dispatch(
        'question/delete',
        JSON.parse(JSON.stringify(this.editedQuestion)),
      );
      this.close();
      this.$emit('refreshQuestion');
    },
    changeType(value) {
      this.editedQuestion.type = this.types.indexOf(value);
    },
    close() {
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
        this.editedQuestion = null;
      }
    },
  },
};
</script>

<style></style>
